import React, { Component } from "react";

export default class Projects extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-work" data-section="projects">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">My Work</span>
                <h2 className="colorlib-heading animate-box">
                  Projects
                </h2>
              </div>
            </div>
            <div className="row">
              <div
                className="col-md-4 animate-box"
                data-animate-effect="fadeInRight"
              >
                <div
                  className="project"
                  style={{ backgroundImage: "url(images/img-2.jpg)" }}
                >
                  <div className="desc">
                    <div className="con">
                      <h3>
                        <a
                          href="https://code-connect-samarth.herokuapp.com/"
                          target="_blank"
                        >
                          Code Connect
                        </a>
                      </h3>
                      <span>React-Redux</span>
                      <p className="icon">
                        <span>
                          <a
                            href="https://github.com/samarth18/codeconnect"
                            target="_blank"
                          >
                            <i className="icon-github" />
                          </a>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-4 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <div
                  className="project"
                  style={{ backgroundImage: "url(images/img_bg55.jpg)" }}
                >
                  <div className="desc">
                    <div className="con">
                      <h3>
                        <a
                          href="https://samarth18.github.io/covid19-tracker/"
                          target="_blank"
                        >
                          COVID-19 Tracker
                        </a>
                      </h3>
                      <span>React</span>
                      <p className="icon">
                        <span>
                          <a
                            href="https://github.com/samarth18/covid19-tracker"
                            target="_blank"
                          >
                            <i className="icon-github"></i>
                          </a>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-4 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <div
                  className="project"
                  style={{ backgroundImage: "url(images/img_bg20.jpg)" }}
                >
                  <div className="desc">
                    <div className="con">
                      <h3>
                        <a
                          href="https://webdev-project-team5-client.herokuapp.com/"
                          target="_blank"
                        >
                          Foodie: Restaurant Finder
                        </a>
                      </h3>
                      <span>React</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
